import { alpha, Card, SxProps, Typography } from '@mui/material';

interface Props {
  title: string;
  description: string;
  sx?: SxProps;
}

const CautionCard = ({ title, description, sx }: Props) => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderColor: 'warning.main',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        py: 1,
        px: 2,
        backgroundColor: theme => alpha(theme.palette.warning.dark, 0.1),
        ...sx,
      }}>
      <Typography variant="subtitle2" color="warning.main">
        {title}
      </Typography>
      <Typography variant="subtitle2" color="text.primary">
        {description}
      </Typography>
    </Card>
  );
};

export default CautionCard;
